import { MutableRefObject } from "react";
import FlashIcon from "../FlashIcon";
import { isFirefox } from "react-device-detect";
import { selectCameraBlob } from "@/store/slices/offCanvas";
import { useSelector } from "react-redux";

const VideoFeed = (props: {
  videoRef: MutableRefObject<HTMLVideoElement | null>,
  mediaTrackRef: MutableRefObject<MediaStreamTrack | null>,
  isBlocked: boolean,
}) => {
  const blob = useSelector(selectCameraBlob);

  return (
    <div className={`relative w-full h-full ${blob ? "hidden" : ""}`}>
      <video ref={props.videoRef} id="camera-video" autoPlay playsInline className="w-full h-full" />
      <div className="absolute-center w-4/5 aspect-video !bg-no-repeat" style={{
        background: `linear-gradient(white, white) top left, 
          linear-gradient(white, white) top left,
          linear-gradient(white, white) top right,
          linear-gradient(white, white) top right,
          linear-gradient(white, white) bottom left,
          linear-gradient(white, white) bottom left,
          linear-gradient(white, white) bottom right,
          linear-gradient(white, white) bottom right`,
        backgroundSize: "2px 30px, 30px 2px",
      }}>
        {
          props.isBlocked && <div className="text-white text-center prose flex flex-col justify-center h-full">
            <p className="text-2xl">Camera Blocked</p>
            <span className="text-sm">
              {isFirefox ? "Please use Chrome to use this feature" : "Please allow camera access to use this feature"}
            </span>
          </div>
        }
      </div>
      <FlashIcon mediaTrackRef={props.mediaTrackRef} />
    </div>
  );
}

export default VideoFeed;